import { render, staticRenderFns } from "./PlatformIcon.vue?vue&type=template&id=02094270&scoped=true"
import script from "./PlatformIcon.vue?vue&type=script&lang=js"
export * from "./PlatformIcon.vue?vue&type=script&lang=js"
import style0 from "./PlatformIcon.vue?vue&type=style&index=0&id=02094270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02094270",
  null
  
)

export default component.exports